// extracted by mini-css-extract-plugin
module.exports = {"fauxSelection":"_1da8b54","cardHeader":"_8c0572d","eventDetails":"_f46e3d8","dateTimeContainer":"_0ae1e6d","clockIcon":"_0fe0ead","participants":"_79d85bf"};